import { useQuery } from "@tanstack/react-query"

import type { Status } from "../types"

import { api } from "@/lib/api-client"
import { queryKeys } from "@/lib/query-keys"

type TrainingModule = {
  module_id?: string
  status: Status
  started_at: Date
  completed_at: Date | null
  updated_at: Date
}

type TrainingModules = {
  modules: TrainingModule[]
}

function getTrainingModules(): Promise<TrainingModules> {
  return api.get(`/training/modules`)
}

export function useGetTrainingModules() {
  const trainingModulesQuery = useQuery({
    queryKey: queryKeys.trainingModules,
    queryFn: () => getTrainingModules(),
    enabled: true,
  })

  return trainingModulesQuery
}
